/* eslint-disable consistent-return */
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Modal from '../../../UniformComponents/Modal'
import InitOptions from './initOptions'
import Aggregated from './aggregate'
import Raw from './raw'
import { Store, stages } from './store'
import Downloading from './downloading'
import DownloadOptions from './downloadOptions'

import './downloadModal.scss'

@observer
class DownloadModal extends Component {
    constructor(props) {
        super(props)
        this.initStore(props.pageType)
    }

    // eslint-disable-next-line react/sort-comp
    initStore = (pageType) => {
        const { store } = this.props
        const reportStore = R.pathOr(null, ['props', 'reportStore'], this)
        if (pageType === 'survey') {
            this.store = new Store(pageType, store)
        } else if (pageType === 'report') {
            this.store = new Store(pageType, store, reportStore)
        } else {
            console.warn('Invalid pageType props: ', pageType)
        }
    }

    onClose = () => {
        const { pageType, store } = this.props
        this.store.reset(pageType)
        store.downloadModalOpen = false
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { pageType } = this.props

        if (pageType !== props.pageType && props.pageType === 'translate') {
            this.store.stage = stages.SELECT_DOWNLOAD_OPTIONS
            this.store.downloadType = 'csv'
        } else {
            this.store.reset()
        }
    }

    renderContent = (pageType) => {
        const { store } = this
        const { stage } = store
        if (!stage) return

        switch (stage) {
            case stages.INIT_OPTIONS:
                return <InitOptions store={store} onClose={this.onClose} />
            case stages.PICK_AGGREGATED_FORMATS:
                return <Aggregated store={store} onClose={this.onClose} />
            case stages.PICK_RAW_FORMATS:
                return <Raw store={store} onClose={this.onClose} />
            case stages.SELECT_DOWNLOAD_OPTIONS:
                return <DownloadOptions store={store} pageType={pageType} onClose={this.onClose} />
            case stages.NOT_AVAILABLE:
                return <NA />
            case stages.DOWNLOADING:
                return <Downloading store={store} pageType={pageType} onClose={this.onClose} />
            default:
                return null
        }
    }

    render() {
        const { store: appStore, pageType } = this.props
        const show = R.pathOr(false, ['downloadModalOpen'], appStore)

        return (
            <Modal show={show} onClose={() => this.onClose(pageType)} cssClass="download large">
                {this.renderContent(pageType)}
            </Modal>
        )
    }
}

export default DownloadModal

const NA = () => (
    <div style={{ textAlign: 'center', marginBlock: 46 }}>
        <h2>This feature is not available yet</h2>
    </div>
)
